import React from 'react';
/*import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';*/
import PropTypes from 'prop-types';
import AuthContext from "./auth/Context";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import groupBy from "lodash/groupBy";
import SlideFile from "./SlideFile";
class BienThe extends React.Component{
  constructor(props){
    super(props);
    //tao danh sach cac bien the tu danh sach thuoc tinh
    let ds_thuoc_tinh = (this.props.product || {}).ds_thuoc_tinh||[];
    const chi_tiet_thuoc_tinh = ds_thuoc_tinh.map(tt=>{
      tt.details = tt.details || [];
      if(tt.details.length==0){
        tt.details.push({
          ten_bien_the:"Biến thể",
          gia_tri_bien_the:tt.ten_tt
        })
      }
      return tt.details.map(d=>{
        d.ten_bien_the = d.ten_bien_the || d.ma_bien_the;
        return d;
      })
    }).reduce((a,b)=>a.concat(b),[]);
    const gs = groupBy(chi_tiet_thuoc_tinh,"ten_bien_the");

    const cac_bien_the = Object.keys(gs).map(ten_bien_the=>{
      let cac_gia_tri_bien_the = [...new Set(gs[ten_bien_the].map(b=>b.gia_tri_bien_the))]
      cac_gia_tri_bien_the = cac_gia_tri_bien_the.map(gia_tri_bien_the=>{
        return {
          gia_tri_bien_the,
          thuoc_tinh_lien_quan:ds_thuoc_tinh.filter(tt=>tt.details.find(d=>d.ten_bien_the===ten_bien_the && d.gia_tri_bien_the===gia_tri_bien_the)).map(t=>t.ma_tt)
        }
      })
      return {
        ten_bien_the,
        gia_tri:cac_gia_tri_bien_the
      }
    })
    //
    this.state={
      value:this.props.value,
      cac_bien_the,
      ds_thuoc_tinh,
      thuoc_tinh:null,
      bien_the_da_chon:{},
      ds_thuoc_tinh_ma_tt:[],
      load:0
    }
  }
  shouldComponentUpdate(newProps,newStates){
    return newStates.load!=this.state.load;
  }
  handleValueChanged(row,gia_tri_bien_the){
    let bien_the = ((row.gia_tri||[]).find(g=>g.gia_tri_bien_the==gia_tri_bien_the)||[])
    let ds_thuoc_tinh_ma_tt = bien_the.thuoc_tinh_lien_quan||[];

    const bien_the_da_chon = this.state.bien_the_da_chon;
    bien_the_da_chon[row.ten_bien_the] = bien_the;

    let ma_tt;
    for(let key in bien_the_da_chon){
      let thuoc_tinh_da_chon = (bien_the_da_chon[key].thuoc_tinh_lien_quan||[]).filter(t=>ds_thuoc_tinh_ma_tt.indexOf(t)>=0);
      if(thuoc_tinh_da_chon.length==0){
        delete bien_the_da_chon[key];
      }
      if(thuoc_tinh_da_chon.length==1){
        ma_tt = thuoc_tinh_da_chon[0];
      }
    }
    let thuoc_tinh;
    let {cac_bien_the,ds_thuoc_tinh} = this.state;
    if(ma_tt){
      //xac dinh thuoc tinh
      thuoc_tinh = ds_thuoc_tinh.find(t=>t.ma_tt==ma_tt);
      //
      cac_bien_the.filter(row=>!bien_the_da_chon[row.ten_bien_the] && row.gia_tri && row.gia_tri.length>0).forEach(row=>{
        let bien_the_def = row.gia_tri.find(g=>(g.thuoc_tinh_lien_quan||[]).indexOf(ma_tt)>=0);
        if(bien_the_def){
          bien_the_da_chon[row.ten_bien_the] = bien_the_def;
        }
      })
    }
    this.setState({bien_the_da_chon,ma_tt,thuoc_tinh,ds_thuoc_tinh_ma_tt,load:this.state.load+1},()=>{
      //console.log("thuoc tinh da chon",ma_tt);
      if(this.props.onValueChanged) this.props.onValueChanged(ma_tt,thuoc_tinh);
    });
  }
  render(){
    const {bien_the_da_chon,cac_bien_the,thuoc_tinh} = this.state;
    if(cac_bien_the.length==0) return null;
    let images = [];
    if(thuoc_tinh){
      if(thuoc_tinh.picture){
        images.push(thuoc_tinh.picture)
      }
      if(thuoc_tinh.picture2){
        images.push(thuoc_tinh.picture2)
      }
      if(thuoc_tinh.picture3){
        images.push(thuoc_tinh.picture3)
      }
    }
    if(images.length==0 && this.props.product && this.props.product.picture_thumb){
      images.push(this.props.product.picture_thumb)
    }
    return (
      <div style={{display:"flex",flexDirection:"row",width:"100%",alignItems:"center"}}>
        <div style={{flex:1}}>
          {cac_bien_the.map(row=>{
            let value = (bien_the_da_chon[row.ten_bien_the]||{}).gia_tri_bien_the ||"";
            return (
              <div key={row.ten_bien_the} style={{marginTop:5}}>
                <FormControl>
                  <FormLabel>{row.ten_bien_the}</FormLabel>
                  <RadioGroup
                    value={value}
                    onChange={event=>this.handleValueChanged(row,event.target.value)}
                    row
                  >
                    {(row.gia_tri||[]).map(bien_the=>{
                      return (
                        <FormControlLabel key={bien_the.gia_tri_bien_the} value={bien_the.gia_tri_bien_the} control={<Radio  size="medium" color={this.context.config.primaryColor}  />} label={bien_the.gia_tri_bien_the} />
                      )
                    })}
                  </RadioGroup>
                </FormControl>
              </div>
            )
          })}
        </div>
        {images && images.length>0 &&
        <div style={{width:100}}>
          <SlideFile
              images={images}
              height={64}
              style={{display:"flex",flexDirection:"column",justifyContent:"center"}}
              mode="fill"
              arrows={false}
              slidesToShow ={1}
              dotImage={false}
          />
        </div>}
      </div>
    )
  }
}

BienThe.propTypes={
  product: PropTypes.any,
  onValueChanged:PropTypes.func,
}
BienThe.contextType = AuthContext;
export default BienThe;